import React from 'react';
import { BooleanField } from 'react-admin';

const BooleanFieldByInt = ({source, ...props}) => {
  const record = {...props.record, [source]: Boolean(props.record[source])};
  return <BooleanField {...props} record={record} source={source} />;
};

export default BooleanFieldByInt;
